/**
 * Noop sink (spec 68 §11.1) — the default mount.
 *
 * Every public API is safe to call with zero config because the facade
 * starts pointed at this sink. It performs no network I/O, no console
 * output, and returns inert span handles. A boot function (bootNode /
 * bootWorker / bootBrowser) swaps in a real sink at app startup.
 */
import type { Attributes, Span, SpanKind, TelemetrySink } from './types.js';

const noopSpan: Span = {
  setAttribute() {
    return this;
  },
  setAttributes() {
    return this;
  },
  recordException() {
    return this;
  },
  setError() {
    return this;
  },
  end() {
    /* noop */
  },
};

export class NoopSink implements TelemetrySink {
  readonly name = 'noop';

  emitLog(): void {
    /* noop */
  }

  startSpan(_name: string, _attributes: Attributes, _kind: SpanKind): Span {
    return noopSpan;
  }

  addToCounter(): void {
    /* noop */
  }

  recordHistogram(): void {
    /* noop */
  }

  setGauge(): void {
    /* noop */
  }

  emitEvent(): void {
    /* noop */
  }

  identify(): void {
    /* noop */
  }

  currentContext(): undefined {
    return undefined;
  }

  async flush(): Promise<void> {
    /* noop */
  }

  async shutdown(): Promise<void> {
    /* noop */
  }
}

export const noopSink = new NoopSink();
